import React from "react";
import { useStore } from "../../context/StoreContext";
import { t } from "../../lib/i18n";
import { MapPin, Truck, ShieldCheck } from "lucide-react";

export const Footer = () => {
  const { lang } = useStore();
  return (
    <footer className="mt-24 border-t border-[#e8ddc9] bg-white">
      <div className="max-w-7xl mx-auto px-6 md:px-8 py-14 grid md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <div className="flex items-baseline gap-3 mb-4">
            <span className="font-logo text-4xl" style={{ color: "var(--thiqa-primary)" }}>الثقة</span>
            <span className="text-xs tracking-widest uppercase" style={{ color: "var(--thiqa-gold)" }}>AL-THIQA</span>
          </div>
          <p className="text-sm text-gray-600 leading-relaxed max-w-md">{t(lang, "footer_about")}</p>
          <div className="flex items-center gap-2 mt-4 text-sm text-gray-700">
            <MapPin size={16} style={{ color: "var(--thiqa-primary)" }} />
            <span>İstanbul, Türkiye</span>
          </div>
        </div>
        <div>
          <h4 className="font-semibold mb-4" style={{ color: "var(--thiqa-primary)" }}>{lang === "ar" ? "لماذا الثقة؟" : "Why Al-Thiqa?"}</h4>
          <ul className="space-y-3 text-sm text-gray-700">
            <li className="flex items-center gap-2"><Truck size={16} style={{ color: "var(--thiqa-gold)" }} />{t(lang, "fast_ship")}</li>
            <li className="flex items-center gap-2"><ShieldCheck size={16} style={{ color: "var(--thiqa-gold)" }} />{t(lang, "secure_pay")}</li>
            <li className="flex items-center gap-2"><MapPin size={16} style={{ color: "var(--thiqa-gold)" }} />{t(lang, "from_istanbul")}</li>
          </ul>
        </div>
        <div>
          <h4 className="font-semibold mb-4" style={{ color: "var(--thiqa-primary)" }}>{lang === "ar" ? "تواصل" : "Contact"}</h4>
          <p className="text-sm text-gray-700">WhatsApp: +90 5368 395 820</p>
          <p className="text-sm text-gray-700 mt-1">info@althiqa.com</p>
        </div>
      </div>
      <div className="border-t border-[#e8ddc9] py-5 text-center text-xs text-gray-500">
        © {new Date().getFullYear()} الثقة · Al-Thiqa. {t(lang, "all_rights")}.
      </div>
    </footer>
  );
};
